const BRANDING_SWITCH_DATE_UTC = Date.UTC(2026, 6, 1);

const OLD_COMPANY_NAME_NOMINATIVE = 'Deutsche Tiernahrung Cremer';
const OLD_COMPANY_NAME_DATIVE = 'der Deutschen Tiernahrung Cremer';
const OLD_PARTNERPORTAL_NAME = `${OLD_COMPANY_NAME_NOMINATIVE} Partnerportal`;

const NEW_COMPANY_NAME_NOMINATIVE = 'deuka Tiernahrung Cremer';
const NEW_COMPANY_NAME_DATIVE = 'der deuka Tiernahrung Cremer';
const NEW_PARTNERPORTAL_NAME = `${NEW_COMPANY_NAME_NOMINATIVE} Partnerportal`;

const isBrandingSwitchDateReached = (now: Date = new Date()): boolean => now.getTime() >= BRANDING_SWITCH_DATE_UTC;

export const getCompanyBranding = (now: Date = new Date()): { nominative: string; dative: string; partnerportalName: string } => {
    if (isBrandingSwitchDateReached(now)) {
        return {
            nominative: NEW_COMPANY_NAME_NOMINATIVE,
            dative: NEW_COMPANY_NAME_DATIVE,
            partnerportalName: NEW_PARTNERPORTAL_NAME,
        };
    }

    return {
        nominative: OLD_COMPANY_NAME_NOMINATIVE,
        dative: OLD_COMPANY_NAME_DATIVE,
        partnerportalName: OLD_PARTNERPORTAL_NAME,
    };
};

const companyBranding = getCompanyBranding();

export const COMPANY_NAME_NOMINATIVE = companyBranding.nominative;
export const COMPANY_NAME_DATIVE = companyBranding.dative;
export const PARTNERPORTAL_NAME = companyBranding.partnerportalName;

export const PAGE_META_DESCRIPTION = `DEU·PA - ${PARTNERPORTAL_NAME}`;

export const applyPageMetadata = (): void => {
    document.title = COMPANY_NAME_NOMINATIVE;

    const metaDescription = document.querySelector('meta[name="description"]');
    metaDescription?.setAttribute('content', PAGE_META_DESCRIPTION);

    const manifestLink = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!manifestLink?.href) {
        return;
    }

    void fetch(manifestLink.href)
        .then((response) => response.json())
        .then((manifest: { name?: string }) => {
            manifest.name = PAGE_META_DESCRIPTION;
            const blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
            manifestLink.href = URL.createObjectURL(blob);
        })
        .catch(() => undefined);
};
